/**
* Hreflang cluster for /sworn/*. Only advertises locales that have physical
* mirror routes (SWORN.2 shipped 6). fr/de will be added when their mirrors ship.
*/
const BASE = "https://thainotarylaw.com";
const LOCALES = ["en", "zh", "ja", "ko", "vi", "id"] as const;

export const SWORN_HREFLANG_LINKS = [
  { rel: "alternate", hrefLang: "th", href: `${BASE}/sworn` },
  ...LOCALES.map((l) => ({ rel: "alternate" as const, hrefLang: l, href: `${BASE}/${l}/sworn` })),
  { rel: "alternate", hrefLang: "x-default", href: `${BASE}/sworn` },
];

export function swornEmbassyHreflangLinks(slug: string) {
  const p = (loc?: string) => loc ? `/${loc}/sworn/embassy/${slug}` : `/sworn/embassy/${slug}`;
  return [
    { rel: "alternate", hrefLang: "th", href: `${BASE}${p()}` },
    { rel: "alternate", hrefLang: "x-default", href: `${BASE}${p()}` },
  ];
}

export function swornDocHreflangLinks(slug: string) {
  const p = (loc?: string) => loc ? `/${loc}/sworn/doc/${slug}` : `/sworn/doc/${slug}`;
  return [
    { rel: "alternate", hrefLang: "th", href: `${BASE}${p()}` },
    { rel: "alternate", hrefLang: "x-default", href: `${BASE}${p()}` },
  ];
}
